module.exports = __webpack_public_path__ + "static/media/error.32927242.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/error.svg
// module id = 105
// module chunks = 0